var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_540_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3233 13.3191C27.0666 12.5128 20.3642 15.5969 16.3882 21.5685C12.3819 27.5805 12.1148 35.0035 15.6776 41.4237L15.7733 41.6L13.3948 50.6356L22.7781 48.4385L22.9444 48.5241C29.1529 51.7997 36.3289 51.5377 42.1393 47.8136C47.9346 44.1046 51.1699 37.7147 50.7919 30.7251C50.3132 21.9364 43.0817 14.2917 34.3233 13.3191ZM40.0127 45.7626C37.5182 47.1988 34.7415 47.9144 31.9598 47.9144C28.9513 47.9144 25.9277 47.0778 23.2367 45.4199L17.4363 46.7301L18.8524 41.212C14.7856 34.8019 15.2442 26.9002 20.0165 21.4829C24.4259 16.4788 31.0678 14.7604 37.362 16.9928C43.6058 19.2101 47.6423 24.698 47.9044 31.3096C48.1412 37.3771 45.1932 42.7793 40.0178 45.7575L40.0127 45.7626Z",
    fill: "#C9CBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9265 35.0489C37.8409 35.0136 37.7602 34.9783 37.6746 34.943C37.1454 34.7062 37.0094 34.686 36.8531 34.8322C36.712 34.9632 36.4752 35.2857 36.2484 35.5982C35.5983 36.4851 35.1398 37.0797 34.6257 37.2057C33.7489 37.4275 31.1032 35.709 31.078 35.6939C30.1911 35.1043 29.1983 34.2224 28.4777 33.396C28.4576 33.3758 26.6736 31.2441 26.6736 30.4832C26.6736 29.9994 27.0516 29.5812 27.4497 29.1427C27.999 28.543 28.3769 28.0794 28.2409 27.6259C27.9839 26.7389 27.238 25.086 26.8349 24.2495C26.5124 23.5944 26.3209 23.3777 25.7766 23.3777C25.6053 23.3777 25.3987 23.3978 25.1467 23.4331C23.8768 23.6095 22.8084 25.7311 22.7026 27.0715C22.4153 30.8007 27.2783 36.344 30.6245 38.3698C32.3076 39.3928 35.6739 40.7534 37.6141 40.6174C38.7983 40.5367 39.912 39.9774 40.5974 39.1106C40.9854 38.6218 41.4087 37.8205 41.2828 36.727C40.7284 36.3641 38.4607 35.2706 37.9265 35.0489Z",
    fill: "#C9CBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappUnavailable);
export default __webpack_public_path__ + "static/media/whatsapp-unavailable.f19e1502e1bc5c0818c458dc80954691.svg";
export { ForwardRef as ReactComponent };